import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';
import amplitudeService from '@features/analytics/amplitudeService';

export const Route = createFileRoute('/preview/')({component: PreviewPage});

function PreviewPage() {
  const navigate = useNavigate();

  useEffect(() => {
    amplitudeService.logEvent('[Preview] page redirecting to /');
    void navigate({to: '/'});
  }, [navigate]);

  return null;
}
